var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 5.84375C41.7888 5.84375 52.1562 16.2112 52.1562 29C52.1562 41.7888 41.7888 52.1562 29 52.1562C16.2112 52.1562 5.84375 41.7888 5.84375 29C5.84375 16.2112 16.2112 5.84375 29 5.84375ZM29 9.40625C18.1787 9.40625 9.40625 18.1787 9.40625 29C9.40625 39.8213 18.1787 48.5938 29 48.5938C39.8213 48.5938 48.5938 39.8213 48.5938 29C48.5938 18.1787 39.8213 9.40625 29 9.40625ZM29 38.5C29.9838 38.5 30.7812 39.2975 30.7812 40.2812V42.6562C30.7812 43.64 29.9838 44.4375 29 44.4375C28.0162 44.4375 27.2188 43.64 27.2188 42.6562V40.2812C27.2188 39.2975 28.0162 38.5 29 38.5ZM29 13.5625C34.2345 13.5631 38.5 17.8279 38.5 23.0625C38.5 27.6883 35.1681 31.5531 30.7812 32.3909V33.1562C30.7812 34.1399 29.9837 34.9374 29 34.9375C28.0162 34.9375 27.2188 34.14 27.2188 33.1562V30.7812C27.2188 29.7978 28.0167 29.0005 29 29C32.267 28.9994 34.9375 26.3296 34.9375 23.0625C34.9375 19.7954 32.267 17.1256 29 17.125C26.3812 17.1254 24.2365 18.8439 23.3501 21.2372C23.0463 22.1723 22.0425 22.6836 21.1073 22.3806C20.1718 22.0767 19.6601 21.0733 19.9639 20.1378C21.3729 16.3042 24.8141 13.5629 29 13.5625Z",
    fill: "#2F7A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionModel);
export default __webpack_public_path__ + "static/media/question-model.1e99b2ebb8d210c7ef643c4ce92ba528.svg";
export { ForwardRef as ReactComponent };